export const getters = {
  systemCommissions: state => state.commissions,
  Commission: state => state.systemCommission,
  commissionItemsrows: state => state.commission_items
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/commissions/getters.js